export default __webpack_public_path__ + "static/media/White0002.77096c58.png";